import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../theme/hooks/useAlerts'
import { queryKey as projectdossierQueryKey } from '../hooks/useProjectdossier'
import { unlinkProjectFromProjectdossier } from '../services/unlinkProjectFromProjectdossier'

export { useUnlinkProjectFromProjectdossier }

const useUnlinkProjectFromProjectdossier = () => {
  const { successAlert, errorAlert } = useAlerts()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: unlinkProjectFromProjectdossier,
    onSuccess: (data) => {
      queryClient.setQueryData(
        [projectdossierQueryKey, data.projectdossierId],
        data,
      )
      successAlert('Koppeling met project verwijderd')
    },
    onError: (error: any) => {
      errorAlert('Fout bij het verwijderen van koppeling met project', error)
    },
  })
}
